import { SRGBColorSpace, WebGLRenderer } from "three";
import { ENVIRONMENT_IS_TEST } from "@messages/environment";
import { capabilitiesService } from "./CapabilitiesService";
function createRendererSpy() {
    const renderer = jest.fn();
    renderer.getSize = jest.fn(() => {
        return { width: 100, height: 100 };
    });
    renderer.getPixelRatio = jest.fn(() => {
        return 1;
    });
    renderer.capabilities = { isWebGL2: false };
    return renderer;
}
export function createRenderer() {
    if (ENVIRONMENT_IS_TEST) {
        return createRendererSpy();
    }
    const renderer = new WebGLRenderer({
        // Use the browser's native MSAA when post effects are disabled.
        antialias: true,
        alpha: true,
        // Auf Low-End-GPUs "low-power" verwenden, um Überhitzung und übermäßigen
        // Akku-Verbrauch zu vermeiden. Auf leistungsfähiger Hardware "high-performance"
        // nutzen, damit der Browser ggf. die dedizierte GPU bevorzugt.
        powerPreference: capabilitiesService.isLowEndGPU ? "low-power" : "high-performance",
        stencil: true
    });
    // Pixel Ratio auf max. 2 begrenzen – auf HiDPI-Displays würde devicePixelRatio (z. B. 3)
    // drastisch mehr GPU-Arbeit erzeugen ohne sichtbaren Mehrwert.
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.outputColorSpace = SRGBColorSpace;
    // Shader-Fehlerprüfung kostet bei jedem Shader-Kompilierungsvorgang Zeit.
    // Nur im Entwicklungsmodus aktivieren.
    renderer.debug.checkShaderErrors = process.env.NODE_ENV === "development";
    return renderer;
}
export const renderer = createRenderer();
export const cubeMapRenderer = createRenderer();
